export const enableCloudWatchSnippet =
  `spring.cloud.aws.cloudwatch.enabled: true`

export const setCloudWatchNamespaceSnippet =
  `management.metrics.export.cloudwatch.namespace: some-namespace`

export const setCloudWatchIntervalSnippet =
  `management.metrics.export.cloudwatch.step: 30s`

